import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);
type DateFormat =
    | 'dateOnly' // → YYYY-MM-DD
    | 'dateTime' // → YYYY-MM-DD HH:mm:ss
    | 'time12h' // → h:mm A
    | 'time24h' // → HH:mm
    | 'fullPretty' // → dddd, MMM D, YYYY h:mm A
    | 'slashDateTime'; // → YYYY/MM/DD - h:mm A

const formats: Record<DateFormat, string> = {
    dateOnly: 'YYYY-MM-DD',
    dateTime: 'YYYY-MM-DD HH:mm:ss',
    time12h: 'h:mm A',
    time24h: 'HH:mm',
    fullPretty: 'dddd, MMM D, YYYY h:mm A',
    slashDateTime: 'YYYY/MM/DD - h:mm A',
};

export const formatDate = (
    dateString: string,
    format: DateFormat = 'dateTime',
    useUTC = false
): string => {
    const date = useUTC ? dayjs.utc(dateString) : dayjs(dateString);
    return date.format(formats[format]);
};
